/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Loader from '../../common/LoadingSpinner';
import { FRONTEND_SERVER, SERVER_URL } from '../../../config';
import history from '../../../history';
import actions from '../../../actions';
import InfiniteScroll from '../../common/InfiniteScroll';
import * as api from '../../../epics/api';
import { uiCategorySettings } from './settings';

class NotificationsBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: this.props.notifications.content,
            nextPage: this.props.notifications.meta.next,
            hasMoreItems: !!this.props.notifications.meta.next,
        };
        this.handleClick = this.handleClick.bind(this);
        this.goToNotificationsListPage =
            this.goToNotificationsListPage.bind(this);
        this.getMoreDate = this.getMoreDate.bind(this);
        this.goToUrl = this.goToUrl.bind(this);
    }

    componentDidMount() {
        setTimeout(
            () => document.addEventListener('click', this.handleClick, false),
            0,
        );
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = e => {
        if (!ReactDOM.findDOMNode(this).contains(e.target)) {
            this.props.closeNotifications();
        }
    };

    goToNotificationsListPage() {
        this.props.closeNotifications();
        history.push('/operations/notifications');
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            notifications: nextProps.notifications.content,
            nextPage: nextProps.notifications.meta.next,
            hasMoreItems: !!nextProps.notifications.meta.next,
        });
    }

    getMoreDate(page) {
        const self = this;
        api.executeHttpRequest(this.state.nextPage, 'get', {}, false).then(
            res => {
                self.setState({
                    notifications: [
                        ...self.state.notifications,
                        ...res.data.content,
                    ],
                    nextPage: res.data.meta.next,
                    hasMoreItems: !!res.data.meta?.next,
                });
            },
        );
    }

    goToUrl(e, url, idToRead) {
        if (url) {
            const self = this;
            e.preventDefault();
            const browse = function () {
                if (url.startsWith(FRONTEND_SERVER)) {
                    self.props.closeNotifications();
                    history.push(url.replace(FRONTEND_SERVER, ''));
                    return false;
                }
                window.location.href = url;

                return true;
            };
            if (idToRead) {
                api.executeHttpRequest(`notifications/${idToRead}/`).then(
                    browse,
                );
            } else {
                return browse();
            }
        }
    }

    render() {
        const self = this;
        return (
            <div className="notificationsBox">
                <div className="inner">
                    {this.props.notifications.fetching &&
                    !this.state.notifications.length != 0 ? (
                        <Loader color="gray" />
                    ) : (
                        <InfiniteScroll
                            pageStart={1}
                            loadMore={this.getMoreDate}
                            initialLoad={false}
                            useWindow={false}
                            hasMore={this.state.hasMoreItems}
                            loader={<Loader color="gray" />}
                        >
                            <ul>
                                {this.state.notifications.length == 0 ? (
                                    <p className="empty">
                                        No new notifications
                                    </p>
                                ) : (
                                    this.state.notifications.map(
                                        (notification, i) => {
                                            let notificationSettings;
                                            let url;
                                            const borderStyle = {};
                                            try {
                                                notificationSettings =
                                                    uiCategorySettings[
                                                        notification.category
                                                    ];
                                                url =
                                                    notificationSettings.url.replace(
                                                        '%s',
                                                        notification[
                                                            notificationSettings
                                                                .pkName
                                                        ],
                                                    );
                                                borderStyle.borderLeftColor =
                                                    notificationSettings.color;
                                            } catch (e) {}

                                            return (
                                                <li key={i}>
                                                    <a
                                                        href={url}
                                                        style={borderStyle}
                                                        className={`notifications-content ${
                                                            !notification.is_read
                                                                ? 'unread'
                                                                : ''
                                                        }`}
                                                        onClick={e =>
                                                            self.goToUrl(
                                                                e,
                                                                url,
                                                                !self.props.user
                                                                    .isAgent ||
                                                                    !notification.case
                                                                    ? notification.id
                                                                    : null,
                                                            )
                                                        }
                                                    >
                                                        <span>
                                                            {
                                                                notification.message
                                                            }
                                                        </span>
                                                        <span
                                                            className="timestamp"
                                                            title={moment(
                                                                notification.datetime_created,
                                                            ).format('L LT')}
                                                        >
                                                            {moment(
                                                                notification.datetime_created,
                                                            ).fromNow()}
                                                        </span>
                                                    </a>
                                                </li>
                                            );
                                        },
                                    )
                                )}
                            </ul>
                        </InfiniteScroll>
                    )}
                    {this.props.user.isAgent || this.props.user.isClient ? (
                        <div className="footer">
                            <a onClick={() => this.goToNotificationsListPage()}>
                                View all
                            </a>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    notifications: state.notifications,
    user: state.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    closeNotifications: () => dispatch(actions.closeNotifications({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsBox);
